//accounts/services/getSquadList (READ)
import {  isLoaded, isLoading } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import * as actions from '../actions';



export async function getCategories(dispatch, getUser) {
    dispatch(isLoading());
    try {
      var response = await API.post("categories.php",{
        action : "account_categories"
      } , {}, false);
      if (response.status === 'True') {
        dispatch(actions.categories(response.data))
      }
      else {
        dispatch(actions.categories([]))
      }
    } catch (error) {
      Alert('error', error.message);
    }
    dispatch(isLoaded());
  }